/**
 * @fileoverview CSS module for the Stepper component in the Storyteller web application.
 * This file contains styles for the stepper component, including progress indicators and step details.
 *
 * @example
 * // Basic usage in Stepper component
 * import css from './Stepper.module.css'
 *
 * <div className={css.container}>
 *   <div className={css.progress}>
 *     <div className={css.progressItem}></div>
 *   </div>
 * </div>
 */

.title {
    color: var(--neutral-900, #171717);
    font-family: Inter;
}

.time {
    color: var(--indigo-800, #3730a3);
    font-family: Inter;
    font-size: 0.875rem;
    padding: 0.25rem 0 0.5rem;
}

.details {
    display: flex;
    flex-direction: column;
}

.container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
}

.cta {
    padding: 10px 12px;
}

.progress {
    width: 100%;
    position: relative;
    justify-content: center;
    display: flex;
    flex-shrink: 0;
    gap: 0.5rem;
}

.progress-container {
    display: flex;
    flex-direction: column;
    margin: 1rem 1rem 0 1rem;
    flex-grow: 1;
}

.progress-item-mobile {
    display: flex;
    width: 100%;
    background: var(--indigo200);
    height: 0.25rem;
    border-radius: 4px;
}

.progress-item-mobile.active,
.progress-item-mobile.completed {
    background: var(--indigo700);
}

.progress-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    transition: all 0.2s ease-in-out;
    padding: 0 0.5rem;
}

.progress-item::after {
    content: '';
    position: absolute;
    left: 0%;
    top: 17px;
    width: 100%;
    height: 2px;
    background: var(--indigo-200, #c7d2fe);
}

.progress-item:first-of-type::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 17px;
    width: 50%;
    height: 2px;
    background: var(--indigo-200, #c7d2fe);
}

.progress-item:last-of-type::after {
    content: '';
    position: absolute;
    left: 0%;
    top: 17px;
    width: 50%;
    height: 2px;
    background: var(--indigo-200, #c7d2fe);
}

.progress-item .num {
    border: 2px solid var(--indigo-200, #c7d2fe);
    background: #eef2ff;
    outline: 8px solid #eef2ff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    border-radius: 40px;
    text-align: center;
    font-size: 1.125rem;
    font-family: Inter;
    font-weight: 400;
    line-height: 1.375rem;
    z-index: 1;
    letter-spacing: -0.01238rem;
    margin-bottom: 0.5rem;
}

.progress-item.active .num {
    border: 2px solid var(--indigo-700, #4338ca);
    background: var(--indigo-700, #4338ca);
    color: var(--neutral-white, #fff);
}

.progress-item.completed .num {
    background: var(--indigo-200, #c7d2fe);
}

.progress-item.active .title {
    font-weight: 400;
}

.progress-item .title {
    display: block;
    color: var(--neutral-900, #171717);
    white-space: nowrap;
    text-align: center;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 300;
    line-height: 1.25rem;
    letter-spacing: -0.011rem;
}

.progress-item .time {
    display: block;
    color: var(--neutral-500, #737373);
    text-align: center;
    font-size: 0.875rem;
    font-family: Inter;
    line-height: 1.25rem;
}

.progress-item.active .time {
    color: var(--indigo-800, #3730a3);
}

.progress-item.completed .time {
    color: var(--neutral-500, #737373);
}

@media (min-width: 768px) {
    .progress-container {
        margin: 0;
    }

    .progress {
        padding: 1.5rem 0 0;
        gap: 0rem;
    }

    .time {
        padding: 0.25rem 0 0;
    }
}

@media (min-width: 1280px) {
    .progress-container .line {
        top: calc(1.5rem + 22px);
    }

    .progress-item {
        padding: 0 1.5rem;
    }

    .progress-item .num {
        width: 2.5rem;
        height: 2.5rem;
        box-sizing: border-box;
    }

    .progress-item:first-of-type::after {
        top: 20px;
    }

    .progress-item::after {
        top: 20px;
    }

    .progress-item:last-of-type::after {
        top: 20px;
    }
}
